import React from 'react';

const Buttom = props => (
  <>
    <a  className="btnComponent"
        style={{"marginLeft": "5px"}}
        href={props.src || ""}
        target={ props.target || "_portfolio" }>
          {props.title || "VISIT" }
          </a>
  </>
)
export default Buttom